import { render } from "./ClueGogoView.vue?vue&type=template&id=098475f7&scoped=true&ts=true"
import script from "./ClueGogoView.vue?vue&type=script&lang=ts"
export * from "./ClueGogoView.vue?vue&type=script&lang=ts"

import "./ClueGogoView.vue?vue&type=style&index=0&id=098475f7&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098475f7"]])

export default __exports__